import request from '../utils/request';

// 获取商品列表（文案中英切换在前端 localizeProduct，无需改数据库）
export const getProducts = (params) => {
  return request({
    url: '/products',
    method: 'get',
    params,
  });
};

export const getProductDetail = (id) => {
  return request({
    url: `/products/${id}`,
    method: 'get',
  });
};

// 创建订单/支付
export const createPayment = (data) => {
  return request({
    url: '/payment',
    method: 'post',
    data,
  });
};
